import { useCallback, useState } from 'react';
import SettingsService from '../services/SettingsService';
import { errorText } from '../utils/format';
import useAsync from './useAsync';

/** Organization settings: the owner's WhatsApp sending permission and the platform limits that protect them. */
export function useSettingsViewModel() {
  const load = useCallback(() => SettingsService.get(), []);
  const { data, loading, error, reload } = useAsync(load);
  const [saving, setSaving] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const setWhatsappSending = async (enabled) => {
    setSaving(true);
    setFeedback(null);
    try {
      await SettingsService.update({ whatsapp_sending_enabled: enabled });
      await reload({ silent: true });
      setFeedback({ severity: 'success', text: enabled ? 'WhatsApp permission switched on.' : 'WhatsApp permission switched off.' });
    } catch (err) {
      setFeedback({ severity: 'error', text: errorText(err) });
    } finally {
      setSaving(false);
    }
  };

  return {
    settings: data,
    loading,
    error,
    reload,
    saving,
    feedback,
    clearFeedback: () => setFeedback(null),
    setWhatsappSending,
  };
}
